import React from 'react';
import { Box, Typography } from '@material-ui/core';

const ErrorCount: React.FC = ({ children }) =>
  children && children > 0 ? (
    <Typography style={{ color: 'red' }}>
      <Box fontWeight="fontWeightBold">{children}</Box>
    </Typography>
  ) : (
    <Typography>{children}</Typography>
  );

export default ErrorCount;
